import { SocialProvider } from 'modules/authentication/helpers/nativeSocialAuth';

export const AUTH_DOMAINS = [
  'https://test.withlocals.com',
  'https://www.withlocals.com',
  'https://withlocals.com',
  URL_AUTHENTICATION_HOST,
  'https://withlocalsapp.withlocals.com',
];

export const SOCIAL_PROVIDERS: SocialProvider[] = [
  'google',
  'facebook',
  'apple',
];

export const IS_NEW_USER_QUERY_PARAM = 'isNewUser';
